/**
 * Hosted-page routes use `:token`; sync into Vuex before components read `$route`
 */
export function syncHpTokenFromRoute(store, to) {
  const token = to.params?.token;
  if (token) {
    store.dispatch("set_hp_token", token);
  }
}
